import React from 'react'

export default class PortfolioModalsManager {

    rename(projectCollectionId) {
        const projectCollection = gd.session.projectCollections.get(projectCollectionId)

        gd.modals.oneInput('Name', projectCollection.name, 'New name', (name) => {
            projectCollection.name = name
            projectCollection.save()

            gd.bus.triggerEvent('top:header-update')
            gd.modal.hide()
        })
    }

    deletePortfolio(projectCollectionId) {
        const projectCollection = gd.session.projectCollections.get(projectCollectionId)
        gd.modals.confirm.deleteByName('Portfolio',projectCollection.name,()=>{
            gd.api.Portfolio.delete(projectCollectionId)
            gd.modal.hide()
            if (projectCollection.isOpen()) gd.goTo('my-work')
        })
    }

    addUsers(users, multiselect = false, callback) {
        gd.modal.showV4({
            className   : 'modal-add-user',
            component   : require('../add-user/add-portfolio-user'),
            params      : {
                onSubmit: newPortfolioUsers=>{
                    gd.modal.hide()
                    if(callback) callback(newPortfolioUsers)
                },
                users   : users,
                mode    : 'portfolio'
            }
        })
    }
}